import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-erro403',
  templateUrl: './erro403.component.html',
  styleUrls: ['./erro403.component.scss']
})
export class Erro403Component implements OnInit {



  constructor() { }

  ngOnInit() {
  }

  pageInicial() {
    sessionStorage.clear();
    window.location.href = '/';
  }


}



// WEBPACK FOOTER //
// /app/src/app/components/erro-pages/erro403/erro403.component.ts